export const LEGAL = {
  privacy: {
    eyebrow: "PRIVACY POLICY",
    title: "سياسة الخصوصية",
    updated: "آخر تحديث: سبتمبر 2026",
    intro:
      "توضح هذه السياسة كيفية تعامل شيادن الأصول العقارية مع المعلومات التي تصلنا عند استخدامك للموقع أو تواصلك معنا.",
    sections: [
      {
        heading: "1. البيانات التي نجمعها",
        paragraphs: [
          "عند تواصلك معنا عبر واتساب أو الاتصال الهاتفي، نستقبل البيانات التي تقدمها طوعًا مثل: الاسم، رقم الجوال، وتفاصيل طلبك العقاري (المدينة، الحي، نوع العقار، الميزانية).",
          "قد يجمع الموقع تلقائيًا بيانات تصفح عامة وغير محددة للهوية (مثل نوع الجهاز ومدة الزيارة) لأغراض إحصائية وتحسين تجربة الاستخدام.",
        ],
      },
      {
        heading: "2. كيفية استخدام البيانات",
        paragraphs: [
          "نستخدم البيانات التي تقدمها للرد على استفسارك، ومساعدتك في الوصول إلى العقار المناسب، أو دراسة إمكانية تسويق أو تأجير عقارك، والتواصل معك بشأن خدماتنا.",
          "لا نستخدم بياناتك لأي غرض تسويقي خارج نطاق خدمات شيادن الأصول العقارية دون موافقتك.",
        ],
      },
      {
        heading: "3. مشاركة البيانات",
        paragraphs: [
          "لا نبيع بياناتك ولا نشاركها مع أطراف ثالثة لأغراض تجارية. قد نشارك الحد الأدنى الضروري من المعلومات عندما يقتضي إتمام خدمة عقارية ذلك (مثل التواصل بين المالك والباحث عن عقار)، أو عند وجود التزام نظامي يستوجب الإفصاح.",
        ],
      },
      {
        heading: "4. حماية البيانات",
        paragraphs: [
          "نطبق إجراءات تنظيمية وتقنية مناسبة لحماية المعلومات التي تصلنا من الوصول أو الاستخدام غير المصرح به، ويقتصر الاطلاع عليها على من يحتاجها لتقديم الخدمة.",
        ],
      },
      {
        heading: "5. حقوقك",
        paragraphs: [
          "وفقًا لنظام حماية البيانات الشخصية المعمول به في المملكة العربية السعودية، يحق لك طلب الاطلاع على بياناتك أو تصحيحها أو حذفها، ويمكنك ممارسة ذلك بالتواصل معنا مباشرة على الرقم 0551799245 أو عبر البريد الإلكتروني Owner@Shiyadn.com.",
        ],
      },
      {
        heading: "6. التعديلات على هذه السياسة",
        paragraphs: [
          "قد نحدّث هذه السياسة من وقت لآخر، وسيُشار إلى تاريخ آخر تحديث أعلى الصفحة. استمرارك في استخدام الموقع بعد أي تحديث يعني اطلاعك على النسخة المحدثة.",
        ],
      },
    ],
  },
  terms: {
    eyebrow: "TERMS & CONDITIONS",
    title: "الشروط والأحكام",
    updated: "آخر تحديث: سبتمبر 2026",
    intro:
      "تحكم هذه الشروط استخدامك لموقع شيادن الأصول العقارية. باستخدامك للموقع فأنت توافق على ما يلي:",
    sections: [
      {
        heading: "1. طبيعة خدماتنا",
        paragraphs: [
          "شيادن الأصول العقارية منشأة متخصصة في التسويق العقاري والوساطة العقارية والتأجير للغير. المحتوى المعروض في الموقع تعريفي وتسويقي، ولا يمثل بحد ذاته عرضًا تعاقديًا ملزمًا.",
        ],
      },
      {
        heading: "2. العقارات المعروضة",
        paragraphs: [
          "تُعرض العقارات المختارة في الموقع لأغراض التسويق، وتخضع التفاصيل النهائية (الأسعار، المواصفات، التوفر) للتحقق والاتفاق المباشر بين الأطراف. التواصل عبر واتساب لا يُعد حجزًا أو التزامًا بإتمام صفقة.",
        ],
      },
      {
        heading: "3. استخدام الموقع",
        paragraphs: [
          "يلتزم المستخدم باستخدام الموقع وقنوات التواصل الموضحة فيه للأغراض المشروعة فقط، ويُمنع إساءة استخدام قنوات التواصل أو تقديم معلومات مضللة.",
        ],
      },
      {
        heading: "4. الملكية الفكرية",
        paragraphs: [
          "جميع محتويات هذا الموقع — بما فيها الاسم التجاري «شيادن الأصول العقارية» وعلامة SHIYADN والتصميم والنصوص — ملك لشيادن الأصول العقارية، ولا يجوز نسخها أو إعادة استخدامها دون إذن كتابي مسبق.",
        ],
      },
      {
        heading: "5. حدود المسؤولية",
        paragraphs: [
          "نحرص على دقة محتوى الموقع، دون أن نضمن خلوه من الأخطاء أو تحديثه لحظة بلحظة. لا تتحمل شيادن الأصول العقارية مسؤولية أي قرارات تُتخذ بناءً على المحتوى التعريفي وحده قبل التحقق المباشر.",
        ],
      },
      {
        heading: "6. القانون الواجب التطبيق",
        paragraphs: [
          "تخضع هذه الشروط للأنظمة المعمول بها في المملكة العربية السعودية، وتختص الجهات القضائية المختصة في المملكة بأي نزاع ينشأ عنها.",
        ],
      },
      {
        heading: "7. التواصل",
        paragraphs: [
          "لأي استفسار يخص هذه الشروط، يمكنك التواصل معنا عبر واتساب أو الاتصال على الرقم 0551799245 أو عبر البريد الإلكتروني Owner@Shiyadn.com.",
        ],
      },
    ],
  },
};
